import { motion } from 'framer-motion';
import { PawPrint, TriangleAlert, DollarSign, Repeat } from 'lucide-react';
import { PredefinedButtonsProps } from '@/types';

export function PredefinedButtons({
  t,
  isLoading,
  handlePromptSubmission,
  formAnswerId,
}: PredefinedButtonsProps) {
  const iconWrapperClasses =
    'flex h-10 w-10 items-center justify-center rounded-full border-2';

  const buttonData = [
    {
      label: t('home.buttons.one'),
      icon: (
        <div className={`${iconWrapperClasses} border-teal-500 bg-teal-100 dark:bg-teal-900`}>
          <Repeat className="text-teal-700 dark:text-teal-400" strokeWidth={2} />
        </div>
      ),
    },
    {
      label: t('home.buttons.two'),
      icon: (
        <div className={`${iconWrapperClasses} border-pink-300 bg-pink-100 dark:bg-pink-900`}>
          <PawPrint className="text-pink-500 dark:text-pink-400" strokeWidth={2} />
        </div>
      ),
    },
    {
      label: t('home.buttons.three'),
      icon: (
        <div className={`${iconWrapperClasses} border-pink-300 bg-pink-100 dark:bg-pink-900`}>
          <TriangleAlert className="text-pink-500 dark:text-pink-400" strokeWidth={2} />
        </div>
      ),
    },
    {
      label: t('home.buttons.four'),
      icon: (
        <div className={`${iconWrapperClasses} border-teal-500 bg-teal-100 dark:bg-teal-900`}>
          <DollarSign className="text-teal-700 dark:text-teal-400" strokeWidth={2} />
        </div>
      ),
    },
  ];

  return (
    <div className="my-6 px-3">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {buttonData.map((btn, idx) => (
          <motion.button
            key={idx}
            initial={{ opacity: 0, y: 30, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{
              type: 'spring',
              stiffness: 100,
              damping: 12,
              delay: 0.2 + idx * 0.1,
            }}
            className={`flex min-h-[70px] items-center justify-center rounded border-2 border-purple-200 dark:border-purple-700 bg-card dark:bg-gray-800 px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300 shadow-md hover:bg-purple-100 dark:hover:bg-purple-900 ${
              isLoading ? 'cursor-not-allowed opacity-50' : ''
            }`}
            onClick={() => {
              if (!isLoading) {
                handlePromptSubmission(btn.label, formAnswerId);
              }
            }}
            disabled={isLoading}
          >
            <span className="mr-3 flex-1">{btn.icon}</span>
            <span className="flex-grow text-center">{btn.label}</span>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
